import axios from "axios";
import { BUSINESS_URL, USERS_URL } from "../../API/Api";

// Get All Users
const getAllUsers = async (data, token) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "GET",
        baseURL: `${USERS_URL}`,
        headers: headers,
        params: { ...data },
    });
    return response.data;
};
// Get Users By Business
const getUserByBusiness = async (business_id, token) => {
    const headers = {
        Accept: `application/json`,
        Authorization: `Bearer ${token}`,
    };

    const response = await axios({
        method: "GET",
        baseURL: `${BUSINESS_URL}/filter/${business_id}`,
        headers,
    });

    return response.data;
};
//getall user
const getAllUsersWihtoutPage = async (token) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "GET",
        baseURL: `${USERS_URL}`,
        headers: headers,
        params: { return_all: "1" },
    });
    return response.data;
};

// Search User
const UsersSearch = async (data, token) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "GET",
        baseURL: `${USERS_URL}`,
        headers: headers,
        params: { ...data },
    });
    // params: data,
    return response.data;
};

//create user
const createUser = async (token, data) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "POST",
        baseURL: `${USERS_URL}/create`,
        headers: headers,
        data: data,
    });
    return response.data;
};

//create user documents
const CreateUserDocuments = async (data, token) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "POST",
        baseURL: `${USERS_URL}/documents/create`,
        headers: headers,
        data: data,
    });
    return response.data;
};

const ShowUserDocuments = async (user_id, token) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "GET",
        baseURL: `${USERS_URL}/documents/${user_id}`,
        headers: headers,
    });
    return response.data;
};

//get sigle
const getSingleUsers = async (token, id) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "GET",
        baseURL: `${USERS_URL}/${id}`,
        headers: headers,
    });
    return response.data;
};

//update
const updateUser = async (token, data) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "POST",
        baseURL: `${USERS_URL}/edit`,
        headers: headers,
        data: data,
    });
    return response.data;
};

//Check
const CheckUserAuthorized = async (token) => {
    const headers = {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
    };
    const response = await axios({
        method: "GET",
        baseURL: `${USERS_URL}/check`,
        headers: headers,
    });
    return response.data;
};
const userService = {
    getAllUsers,
    getUserByBusiness,
    getAllUsersWihtoutPage,
    createUser,
    CreateUserDocuments,
    ShowUserDocuments,
    getSingleUsers,
    updateUser,
    UsersSearch,
    CheckUserAuthorized,
};

export default userService;
